/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The Agent event type :
 * * CPO: Charge Point Operator Role.
 * * EMSP: eMobility Service Provider Role.
 * * HUB: Hub role.
 * * NAP: National Access Point Role (national Database with all Location information of a country).
 * * NSP: Navigation Service Provider Role, role like an eMSP (probably only interested in Location information).
 * * OTHER: Other role.
 * * SCSP: Smart Charging Service Provider Role.
 */
export enum OcpiRole {
  CPO = 'CPO',
  EMSP = 'EMSP',
  HUB = 'HUB',
  NAP = 'NAP',
  NSP = 'NSP',
  OTHER = 'OTHER',
  SCSP = 'SCSP'
}
